import { markRaw } from 'vue'
import registration from './step_registration.vue'
import correction from './step_correction.vue'
import investigation from './step_investigation.vue'
import prepare_to_answer from './step_prepare_to_answer/index.vue'
import delivery_answer from './step_delivery_answer.vue'
import coordination from './step_coordination.vue'

// если COS обращения <= этого этапа,
// обращение можно закрыть без ответов
export const CLOSE_WITHOUT_REPLY = 'investigation'
export const NO_APPROVE_SKIP = ['prepare_to_answer', 'coordination']
export default {
  registration: {
    title: 'Регистрация',
    component: markRaw(registration),
    approveLabel: 'Зарегистрировать',
    slaLabelDone: 'Зарегистрировано {{date_real_finish}}',
    slaLabelProgress: 'Зарегистрировать до {{date_finish}}',
  },
  correction: {
    title: 'Уточнение данных',
    component: markRaw(correction),
    approveLabel: 'Передать в расследование',
    slaLabelDone: 'Данные уточнены {{date_real_finish}}',
    slaLabelProgress: 'Уточнить данные до {{date_finish}}',
  },
  investigation: {
    title: 'Расследование',
    component: markRaw(investigation),
    approveLabel: 'Передать на подготовку ответа',
    slaLabelDone: 'Расследовано {{date_real_finish}}',
    slaLabelProgress: 'Расследовать до {{date_finish}}',
  },
  prepare_to_answer: {
    title: 'Подготовка ответа',
    component: markRaw(prepare_to_answer),
    approveLabel: 'Передать на согласование',
    // backLabel: 'Вернуть на дорасследование',
    slaLabelDone: 'Подготовлено {{date_real_finish}}',
    slaLabelProgress: 'Подготовить до {{date_finish}}',
  },
  coordination: {
    title: 'Согласование ответа',
    component: markRaw(coordination),
    approveLabel: 'Перейти к отправке ответа',
    // backLabel: 'Вернуть на подготовку ответа',
    slaLabelDone: 'Согласовано {{date_real_finish}}',
    slaLabelProgress: 'Согласовать до {{date_finish}}',
  },
  delivery_answer: {
    title: 'Отправка ответа',
    component: markRaw(delivery_answer),
    approveLabel: 'Завершить обращение',
    // backLabel: 'Вернуть на согласование ответа',
    slaLabelDone: 'Завершено {{date_real_finish}}',
    slaLabelProgress: 'Завершить до {{date_finish}}',
  },
}
